import { ReactNode } from 'react';
import { FormControlLabel as MuiFormControlLabel, FormControlLabelProps, TypographyProps } from '@mui/material';
import { Tooltip } from '@components/tooltip/Tooltip';
import { requiredFieldStyle } from '@components/inputLabel/InputLabel.styles';
import { SystemStyleObject } from '@mui/system';

interface IFormControlLabel extends FormControlLabelProps {
  typographyProps?: TypographyProps;
  tooltipTitle?: ReactNode;
  sxProps?: {
    formControlLabel?: SystemStyleObject;
  };
}

export const FormControlLabel = (props: IFormControlLabel) => {
  const { checked, disabled, sxProps, typographyProps, tooltipTitle, sx, ...other } = props;

  const isRequired = Boolean(other?.required);
  const contentLabel = (
    <MuiFormControlLabel
      checked={checked}
      disabled={disabled}
      sx={{
        ...sx,
        '&.MuiFormControlLabel-root': {
          marginRight: 0,
          marginLeft: 0,
          alignItems: 'center',
          ...(sxProps?.formControlLabel || {}),
        },
      }}
      {...other}
      required={false}
      slotProps={{
        typography: {
          color: 'text.main',
          variant: 'bodySmall',
          sx: [
            {
              '&.MuiFormControlLabel-label.Mui-disabled': {
                color: 'text.disabled',
              },
            },
            isRequired ? requiredFieldStyle : {},
          ],
          ...typographyProps,
        },
      }}
    />
  );

  return !tooltipTitle ? (
    contentLabel
  ) : (
    <Tooltip placement='top' title={tooltipTitle} config={{ allowWhiteSpace: true, applyMarkup: true }}>
      {contentLabel}
    </Tooltip>
  );
};
